interface DotSpacerProps {
  marginLeft?: string;
  marginRight?: string;
}

/**
 * Mixin function to create a dot spacer node
 * @param Object Contains the values for the margin left and right properties
 * @returns A serialized css style for dot spaces to use in a styled component
 */
export const dotSpacer = ({
  marginLeft = 'initial',
  marginRight = 'initial'
}: DotSpacerProps): string => `
  content: '';
  display: inline-block;
  vertical-align: middle;
  margin-left: ${marginLeft};
  margin-right: ${marginRight};
  margin-top: -2px; /* vertical-align renders visually slightly low */
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: currentColor;
`;
